export const ABSMARTLY_ID = 'absmartly_id';
export const IN_MOBILE_APP = 'in_mobile_app';
export const LOGGED_IN = 'logged_in';
export const OAUTH_TOKEN = 'oauth_token';
export const USER_ID = 'user_id';
export const USER_ROLES = 'user_roles';
